/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Workout_Add_AlreadyInputs */

const en_us2_workout_add_already = /** @type {(inputs: Workout_Add_AlreadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is already in today's workout`)
};

const pt_br2_workout_add_already = /** @type {(inputs: Workout_Add_AlreadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} já está no treino de hoje`)
};

const es_419_workout_add_already = /** @type {(inputs: Workout_Add_AlreadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ya está en el entrenamiento de hoy`)
};

const pt_pt2_workout_add_already = /** @type {(inputs: Workout_Add_AlreadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} já está no treino de hoje`)
};

const fr_fr2_workout_add_already = /** @type {(inputs: Workout_Add_AlreadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} est déjà dans la séance du jour`)
};

const de_de2_workout_add_already = /** @type {(inputs: Workout_Add_AlreadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist schon im heutigen Training`)
};

const it_it2_workout_add_already = /** @type {(inputs: Workout_Add_AlreadyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} è già nell'allenamento di oggi`)
};

/**
* | output |
* | --- |
* | "{name} is already in today's workout" |
*
* @param {Workout_Add_AlreadyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_add_already = /** @type {((inputs: Workout_Add_AlreadyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Add_AlreadyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_add_already(inputs)
	if (locale === "es-419") return es_419_workout_add_already(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_add_already(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_add_already(inputs)
	if (locale === "de-DE") return de_de2_workout_add_already(inputs)
	if (locale === "it-IT") return it_it2_workout_add_already(inputs)
	return en_us2_workout_add_already(inputs)
});
export { workout_add_already as "workout.add_already" }